var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineRgb = function SvgCrowdvotingFoerdersummenVisualisierungInlineRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "315.7px",
    height: "218.9px",
    viewBox: "0 0 315.7 218.9",
    style: {
      enableBackground: "new 0 0 315.7 218.9"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;fill:#6F6F6E;enable-background:new    ;}\r\n\t.st1{fill:#ED7204;}\r\n\t.st2{fill:#B2B2B2;}\r\n\t.st3{opacity:0.1;fill:#2A251B;enable-background:new    ;}\r\n\t.st4{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st5{fill:#F8B133;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#212529;}\r\n\t.st8{fill:#FBBC30;}\r\n\t.st9{fill:#F3A51B;}\r\n\t.st10{fill:#BE7B12;}\r\n\t.st11{opacity:0.32;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st12{opacity:0.4;}\r\n\t.st13{opacity:0.15;enable-background:new    ;}\r\n\t.st14{opacity:0.49;}\r\n\t.st15{fill:#F3A51B;stroke:#BD7A12;stroke-width:0.1;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3146",
    transform: "translate(-1.273 -0.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13144",
    className: "st0",
    d: "M170.5,205.9c-19.3,0-37.5,0.3-53.4,0.8c-5-2-13.1-3.4-22.3-3.4c-4,0-7.9,0.3-11.9,0.8 c11.8,0.9,20.5,4,20.5,7.7c0,3.2-6.2,5.9-15.3,7.2c2.1,0.2,4.4,0.2,6.7,0.2c5.2,0,10.4-0.4,15.6-1.4c17.4,0.6,38,1,60.2,1 c62.1,0,112.5-2.9,112.5-6.5S232.7,205.9,170.5,205.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blub",
    transform: "translate(1.273 8.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13145",
    className: "st1",
    d: "M243.4,13.2c-7.4,0.2-14.6,1.7-21.4,4.5c-19.8,7.9-41.7,7.7-59.8-1.5 c-5.5-2.8-11.3-5.2-17.1-7.3c-41.3-14.7-86.4-10.8-115,8.1C13.8,27.8,3.4,45.7,0.8,65.4c-6.1,47.6,22.3,80.2,75.1,99 c20.8,7.5,43,10.2,65,7.9c19.9-2.2,39.2,3.7,53.1,16.4c11.9,10.9,26.8,17.2,43.1,16.7c41.6-1.1,76.7-45,78.4-98.1 S285,12.1,243.4,13.2z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_51",
    className: "st0",
    cx: 76.6,
    cy: 211.8,
    rx: 26.9,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    className: "st0",
    cx: 39.9,
    cy: 199.3,
    rx: 26.9,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2907",
    transform: "translate(71.064 0.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13146",
    className: "st2",
    d: "M128.4,41l3.7-12.4l9.7-19.3c1.5-4.8-3.3-9.1-8.4-7.7L121.3,5c-2.3,0.6-4.7,0.5-6.9-0.5 l-5.9-2.6C103-0.6,96.8-0.6,91.2,1.8L83,5.4c-3.7,1.6-7.8,1.5-11.4-0.3l-9-4.5c-1.5-0.7-3.3-0.2-4.3,1.2l0,0 c-0.3,0.6-0.4,1.3-0.3,1.9l9.2,24.8l2.5,11.8C49.2,59.7,0,118.5,0,168.9c0,55,30.2,44.6,97.2,44.8c69.9,0.2,103.6,10.2,103.6-42.4 C200.8,137.7,149.2,60.8,128.4,41z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2906",
    transform: "translate(5.49 31.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13147",
    className: "st3",
    d: "M193.3,152.3c5.3-27.9-23.6-67.6-29.5-77.7c-5.6,25.3,35.7,59.1-10.8,106.9 C168.4,181.3,188.6,177.5,193.3,152.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13148",
    className: "st4",
    d: "M55.3,25.7C25.6,53.7-20,138.8,9.6,136C9.8,112,33.6,62.2,55.3,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13149",
    className: "st3",
    d: "M124.3,4.9l-60.8,0l0.2,0.8H124L124.3,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13150",
    className: "st3",
    d: "M139.9,35.4l-5.2-10.2c-1.2-2.2-2.6-4.2-4.3-5.9l-5.7-7h0.9l-0.7-0.7H60.7l-0.5,0.7l55,0.2 l5.2,19.6l-0.8,17.2c0.3,1.3,1.3,2.3,2.7,2.5h0.6c1.6,0.1,3-1.1,3.2-2.7l-0.4-14.8c-0.3-2.8-1-5.6-2-8.2l-4.5-13.9h2.8l8,12.8 l5.3,13.3c0.7,0.9,1.8,1.3,2.9,1.1l0.4-0.2c1.5-0.6,2.2-2.2,1.6-3.7C140,35.6,140,35.5,139.9,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13151",
    className: "st5",
    d: "M139.2,35.1l-5.1-9.7c-2-3.4-4.4-6-6.8-9.1l-3.8-4.7h2.3c1.4,0,2.6-1.1,2.7-2.5V9 c-0.1-1.4-1.2-2.5-2.7-2.5H60.9c-1.4,0-2.7,1.1-2.7,2.5v0.2c0.1,1.4,1.3,2.6,2.7,2.5h51.3c0,0.2,0.1,0.4,0.2,0.6l3.8,10.3 c0.3,0.9,0.7,1.8,1.1,2.8c1.7,4.2,2.5,8.6,2.5,13.1V49c0,0.9,0.5,1.8,1.3,2.2c0.8,0.4,1.7,0.5,2.5,0.2c1.4-0.6,1.8-1.6,1.8-3.4 l-0.5-13.4c0-1.1-0.2-2.2-0.4-3.3c-0.9-3.9-2-7.7-3.3-11.4l-2.3-6.4l3.8,4.1c0.3,0.4,0.6,0.7,0.9,1.1c1,1.2,2.1,2.6,2.9,3.7 c0.7,0.9,1.9,2.5,2.7,3.5c0.7,1.1,1.3,2.2,1.9,3.3l4.1,8.5c0.2,0.3,0.4,0.6,0.8,0.8c1,0.6,2.2,0.5,3.1-0.2l0,0 C140,37.6,139.8,36.5,139.2,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13152",
    className: "st4",
    d: "M59.8,7h49.7c0.3,0,0.5,0.2,0.6,0.5v0.1c0,0.3-0.3,0.5-0.6,0.5H59.8c-0.3,0-0.5-0.2-0.6-0.5 V7.5C59.3,7.2,59.5,7,59.8,7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13153",
    className: "st4",
    d: "M121.4,44.5h0.1c0.5,0,0.8,0.3,0.9,0.8v1.8c0,0.5-0.4,0.8-0.9,0.8h-0.1 c-0.5,0-0.8-0.3-0.9-0.8v-1.8C120.6,44.8,120.9,44.4,121.4,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13154",
    className: "st4",
    d: "M122.3,49v0.4c0,0.5-0.4,0.8-0.9,0.8l0,0c-0.5,0-0.9-0.3-0.9-0.8V49c0-0.5,0.4-0.8,0.9-0.8 l0,0C121.9,48.2,122.3,48.6,122.3,49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13155",
    className: "st4",
    d: "M137.3,36.2l0.2,0.4c0.2,0.5,0.1,1.1-0.4,1.5l0,0c-0.4,0.2-0.9,0.1-1.1-0.3 c0,0,0-0.1-0.1-0.1l-0.2-0.4c-0.2-0.5-0.1-1.1,0.4-1.5l0,0c0.4-0.2,0.9-0.1,1.1,0.3C137.3,36.1,137.3,36.2,137.3,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13156",
    className: "st5",
    d: "M62.2,0h62.4c1.2-0.1,2.2,0.8,2.3,2.1v0.5c-0.1,1.2-1.1,2.1-2.3,2.1H62.2 C61,4.7,60,3.8,59.9,2.6V2.1C60,0.8,61-0.1,62.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13157",
    className: "st4",
    d: "M62.7,0.5h62.2c0.3,0,0.5,0.2,0.6,0.5v0.1c0,0.3-0.3,0.5-0.6,0.5H62.7 c-0.3,0-0.5-0.2-0.6-0.5V1C62.2,0.7,62.4,0.5,62.7,0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2910",
    transform: "translate(132.079 89.69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2193",
    x: 16.3,
    y: 29.5,
    className: "st6",
    width: 157.1,
    height: 34.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2194",
    x: 0,
    y: 0,
    className: "st6",
    width: 124.6,
    height: 25.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2908",
    transform: "translate(7.061 5.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13158",
    className: "st7",
    d: "M0,0.7h6.9V2H1.7v4h4.9v1.2H1.7v5.4H0V0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13159",
    className: "st7",
    d: "M17,8.2c0.1,2.4-1.8,4.4-4.1,4.5c-0.1,0-0.3,0-0.4,0c-2.3,0.1-4.3-1.7-4.4-4 c0-0.1,0-0.3,0-0.4c0-2.5,2-4.5,4.5-4.5c2.3,0,4.3,1.8,4.5,4.1C17,8,17,8.1,17,8.2z M9.7,8.3c0,1.9,1.2,3.3,2.8,3.3 s2.8-1.4,2.8-3.3c0-1.4-0.8-3.3-2.8-3.3S9.7,6.7,9.7,8.3L9.7,8.3z M9.7,1.6c0-0.5,0.5-0.9,1-0.9c0.5,0,0.9,0.5,0.8,1 c0,0.5-0.5,0.9-1,0.8C10.1,2.5,9.7,2.1,9.7,1.6z M13.3,1.6c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v0l0,0 c0,0.5-0.3,0.9-0.8,1c0,0,0,0,0,0c-0.5,0.1-1-0.3-1-0.8C13.3,1.7,13.3,1.7,13.3,1.6L13.3,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13160",
    className: "st7",
    d: "M19.1,6.7c0-1,0-1.9-0.1-2.7h1.5l0.1,1.6h0.1C21,4.6,22,3.9,23.2,3.9c0.2,0,0.3,0,0.5,0.1 v1.5c-0.2,0-0.4,0-0.6,0c-1.1,0-2.1,0.9-2.2,2c-0.1,0.2-0.1,0.5-0.1,0.7v4.6h-1.7L19.1,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13161",
    className: "st7",
    d: "M33.1,0v10.3c0,0.7,0,1.5,0.1,2.2h-1.5l-0.1-1.5l0,0c-0.7,1.1-1.9,1.7-3.1,1.6 c-2.2,0-3.9-1.8-3.9-4.3c0-2.8,1.9-4.6,4.1-4.6c1.1-0.1,2.1,0.4,2.8,1.3l0,0V0L33.1,0z M31.4,7.5c0-0.2,0-0.4-0.1-0.7 C31.1,5.8,30.1,5,28.9,5c-1.8,0-2.8,1.4-2.8,3.3c0,1.7,0.9,3.2,2.7,3.2c1.1,0,2.2-0.7,2.5-1.8c0.1-0.2,0.1-0.4,0.1-0.7L31.4,7.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13162",
    className: "st7",
    d: "M36.8,8.6c-0.1,1.6,1.1,2.9,2.6,3c0,0,0,0,0,0c0.2,0,0.3,0,0.5,0c0.9,0,1.7-0.1,2.6-0.4 l0.3,1.1c-1,0.4-2,0.6-3.1,0.5c-2.8,0-4.5-1.7-4.5-4.3C35,6.1,36.8,4,39.1,3.8c0.1,0,0.3,0,0.4,0c3,0,3.8,2.5,3.8,4 c0,0.2,0,0.5-0.1,0.7L36.8,8.6z M41.7,7.5c0.1-1.2-0.8-2.4-2-2.5c-0.1,0-0.2,0-0.3,0c-1.4,0-2.5,1.1-2.6,2.5H41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13163",
    className: "st7",
    d: "M45.4,6.7c0-1,0-1.9-0.1-2.7h1.5l0.1,1.6h0.1c0.4-1.1,1.4-1.8,2.6-1.9c0.2,0,0.3,0,0.5,0 v1.5c-0.2,0-0.4-0.1-0.6-0.1c-1.1,0-2.1,0.9-2.3,2c0,0.2-0.1,0.5-0.1,0.7v4.6h-1.7L45.4,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13164",
    className: "st7",
    d: "M51.4,11c0.7,0.4,1.4,0.6,2.2,0.6c1.2,0,1.8-0.6,1.8-1.3s-0.5-1.1-1.7-1.6 c-1.7-0.5-2.4-1.4-2.4-2.4c0-1.4,1.2-2.5,3.2-2.5c0.8,0,1.6,0.2,2.3,0.5l-0.5,1.1C55.7,5.2,55,5,54.4,5c-1,0-1.5,0.5-1.5,1.2 s0.6,1,1.8,1.4c1.6,0.6,2.4,1.3,2.4,2.6c0,1.5-1.3,2.6-3.4,2.6c-0.9,0-1.8-0.2-2.6-0.6L51.4,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13165",
    className: "st7",
    d: "M66.9,10.2c0,0.8,0,1.6,0.1,2.3h-1.5l-0.1-1.4l0,0c-0.7,1-1.8,1.6-3.1,1.6 c-1.4,0-3.2-0.7-3.2-3.7V4h1.7v4.8c0,1.6,0.5,2.7,2.1,2.7c1,0,1.8-0.6,2.2-1.4c0.1-0.3,0.1-0.5,0.2-0.8V4h1.6L66.9,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13166",
    className: "st7",
    d: "M69.7,6.3c0-0.8,0-1.5-0.1-2.3h1.5l0.1,1.4h0.1c0.6-1,1.7-1.6,2.9-1.6 c1.1,0,2.2,0.6,2.6,1.7l0,0c0.3-0.4,0.6-0.8,1-1.1c0.6-0.4,1.3-0.6,2-0.6c1.2,0,3,0.7,3,3.7v5h-1.6V7.7c0-1.6-0.6-2.6-2-2.6 c-0.9,0-1.7,0.6-2,1.4c-0.1,0.3-0.1,0.5-0.1,0.8v5.3h-1.6V7.4c0-1.4-0.6-2.4-1.9-2.4c-1.2,0.1-2.2,1.1-2.2,2.3v5.2h-1.6L69.7,6.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13167",
    className: "st7",
    d: "M85.6,6.3c0-0.8,0-1.5-0.1-2.3H87L87,5.4h0.1c0.6-1,1.7-1.6,2.9-1.6c1.1,0,2.2,0.6,2.6,1.7 l0,0c0.3-0.4,0.6-0.8,1-1.1c0.6-0.4,1.3-0.6,2-0.6c1.2,0,3,0.7,3,3.7v5h-1.7V7.7c0-1.6-0.6-2.6-2-2.6c-0.9,0-1.7,0.6-2,1.4 C93,6.7,92.9,7,92.9,7.3v5.3h-1.6V7.4c0-1.4-0.6-2.4-1.9-2.4c-1.2,0.1-2.2,1.1-2.2,2.3v5.2h-1.6L85.6,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13168",
    className: "st7",
    d: "M102.4,8.6c-0.1,1.6,1.1,2.9,2.7,3c0,0,0,0,0,0c0.2,0,0.3,0,0.5,0c0.9,0,1.7-0.1,2.6-0.4 l0.3,1.1c-1,0.4-2,0.6-3.1,0.5c-2.8,0-4.5-1.7-4.5-4.3c-0.2-2.4,1.6-4.4,3.9-4.6c0.1,0,0.3,0,0.4,0c3,0,3.8,2.5,3.8,4 c0,0.2,0,0.5-0.1,0.7L102.4,8.6z M107.3,7.5c0.1-1.2-0.8-2.4-2-2.5c-0.1,0-0.2,0-0.3,0c-1.4,0-2.5,1.1-2.6,2.5H107.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2909",
    transform: "translate(26.689 34.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13169",
    className: "st7",
    d: "M0,21.1h5.8V5.2H1V2.5C2.2,2.3,3.3,2,4.4,1.7C5.3,1.3,6.2,1,7.1,0.5h3.5v20.7h5.1v3.6H0 L0,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13170",
    className: "st7",
    d: "M28.4,25.2c-2.6,0.1-5-1.2-6.5-3.3c-1.6-2.2-2.4-5.3-2.4-9.4c0-4.1,0.8-7.2,2.4-9.3 c2.6-3.4,7.4-4.2,11-1.9c0.8,0.5,1.4,1.1,2,1.9c1.6,2.1,2.4,5.2,2.4,9.3c0,4.1-0.8,7.2-2.4,9.5C33.4,24,30.9,25.3,28.4,25.2z  M28.4,21.8c0.6,0,1.2-0.2,1.8-0.5c0.6-0.4,1.1-0.9,1.4-1.6c0.4-0.9,0.7-1.9,0.9-2.9c0.2-1.4,0.4-2.9,0.3-4.3 c0-1.4-0.1-2.9-0.3-4.3c-0.2-1-0.5-1.9-0.9-2.8c-0.3-0.6-0.8-1.1-1.4-1.5c-1.1-0.6-2.4-0.6-3.5,0c-0.6,0.4-1.1,0.9-1.4,1.5 c-0.4,0.9-0.7,1.8-0.9,2.8c-0.2,1.4-0.3,2.9-0.3,4.3c0,1.5,0.1,2.9,0.3,4.3c0.2,1,0.5,2,0.9,2.9c0.3,0.6,0.8,1.2,1.4,1.6 C27.2,21.6,27.8,21.7,28.4,21.8L28.4,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13171",
    className: "st7",
    d: "M44.7,25.2c-0.8,0-1.6-0.3-2.2-0.8c-1.2-1.2-1.2-3.1,0-4.3c0.6-0.6,1.4-0.8,2.2-0.8 c0.8,0,1.6,0.3,2.2,0.8c1.2,1.2,1.2,3.1,0,4.3C46.3,24.9,45.5,25.2,44.7,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13172",
    className: "st7",
    d: "M61.1,25.2c-2.6,0.1-5-1.2-6.5-3.3c-1.6-2.2-2.4-5.3-2.4-9.4c0-4.1,0.8-7.2,2.4-9.3 c2.6-3.4,7.4-4.2,11-1.9c0.8,0.5,1.4,1.1,2,1.9c1.6,2.1,2.4,5.2,2.4,9.3c0,4.1-0.8,7.2-2.4,9.4C66.1,24,63.7,25.3,61.1,25.2z  M61.1,21.8c0.6,0,1.2-0.2,1.8-0.5c0.6-0.4,1.1-0.9,1.4-1.6c0.4-0.9,0.7-1.9,0.9-2.9c0.2-1.4,0.4-2.9,0.3-4.3 c0-1.4-0.1-2.9-0.3-4.3c-0.2-1-0.5-1.9-0.9-2.8c-0.3-0.6-0.8-1.1-1.4-1.5c-1.1-0.6-2.4-0.6-3.5,0c-0.6,0.4-1.1,0.9-1.4,1.5 c-0.4,0.9-0.7,1.8-0.9,2.8c-0.4,2.9-0.4,5.7-0.1,8.6c0.2,1,0.5,2,0.9,2.9c0.3,0.6,0.8,1.2,1.4,1.6C59.8,21.6,60.4,21.7,61.1,21.8 L61.1,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13173",
    className: "st7",
    d: "M83.4,25.2c-2.6,0.1-5-1.2-6.5-3.3c-1.6-2.2-2.4-5.3-2.4-9.4c0-4.1,0.8-7.2,2.4-9.3 c2.6-3.4,7.4-4.2,11-1.9c0.8,0.5,1.4,1.1,2,1.9c1.6,2.1,2.4,5.2,2.4,9.3s-0.8,7.2-2.4,9.4C88.4,24,86,25.3,83.4,25.2z M83.4,21.8 c0.6,0,1.2-0.2,1.8-0.5c0.6-0.4,1.1-0.9,1.4-1.6c0.4-0.9,0.7-1.9,0.9-2.9c0.2-1.4,0.4-2.9,0.3-4.3c0-1.4-0.1-2.9-0.3-4.3 c-0.2-1-0.5-1.9-0.9-2.8c-0.3-0.6-0.8-1.1-1.4-1.5c-1.1-0.6-2.4-0.6-3.5,0c-0.6,0.4-1.1,0.9-1.4,1.5c-0.4,0.9-0.7,1.8-0.9,2.8 c-0.2,1.4-0.4,2.9-0.3,4.3c0,1.5,0.1,2.9,0.3,4.3c0.2,1,0.5,2,0.9,2.9c0.3,0.6,0.8,1.2,1.4,1.6C82.2,21.6,82.8,21.8,83.4,21.8 L83.4,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13174",
    className: "st7",
    d: "M105.7,25.2c-2.6,0.1-5-1.2-6.5-3.3c-1.6-2.2-2.4-5.3-2.4-9.4c0-4.1,0.8-7.2,2.4-9.3 c2.6-3.4,7.4-4.2,11-1.9c0.8,0.5,1.4,1.1,2,1.9c1.6,2.1,2.4,5.2,2.4,9.3s-0.8,7.2-2.4,9.4C110.7,24,108.3,25.3,105.7,25.2z  M105.7,21.8c0.6,0,1.2-0.2,1.8-0.5c0.6-0.4,1.1-0.9,1.4-1.6c0.4-0.9,0.7-1.9,0.9-2.9c0.2-1.4,0.4-2.9,0.3-4.3 c0-1.4-0.1-2.9-0.3-4.3c-0.2-1-0.5-1.9-0.9-2.8c-0.3-0.6-0.8-1.1-1.4-1.5c-1.1-0.6-2.4-0.6-3.5,0c-0.6,0.4-1.1,0.9-1.4,1.5 c-0.4,0.9-0.7,1.8-0.9,2.8c-0.2,1.4-0.4,2.9-0.3,4.3c0,1.5,0.1,2.9,0.3,4.3c0.2,1,0.5,2,0.9,2.9c0.3,0.6,0.8,1.2,1.4,1.6 C104.5,21.6,105.1,21.7,105.7,21.8L105.7,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13175",
    className: "st7",
    d: "M138.3,21.6c-0.9,1.1-2,2-3.2,2.6c-1.3,0.6-2.6,0.9-4.1,0.9c-2.4,0.1-4.7-0.8-6.5-2.3 c-1.9-1.8-3.2-4.1-3.5-6.7h-2.6V14l2.3-0.1v-2.3h-2.3V9.5l2.6-0.2c0.2-1.4,0.7-2.7,1.3-3.9c0.6-1.1,1.3-2.1,2.3-2.9 c0.9-0.8,2-1.4,3.1-1.8c1.2-0.4,2.5-0.6,3.8-0.6c1.2,0,2.4,0.3,3.5,0.8c1.1,0.5,2.1,1.3,2.9,2.2l-2.7,2.4c-0.5-0.6-1.1-1-1.8-1.4 c-0.6-0.4-1.4-0.6-2.1-0.5c-1.4,0-2.7,0.5-3.7,1.5c-1,1.2-1.7,2.7-1.9,4.3h9.6v2.3h-9.9c0,0.2,0,0.3,0,0.5v1.2c0,0.2,0,0.4,0,0.6 h8.2v2.3h-7.9c0.3,1.5,0.9,2.9,2,4.1c0.9,1,2.2,1.5,3.5,1.5c0.8,0,1.6-0.2,2.4-0.6c0.8-0.5,1.4-1.1,2-1.8L138.3,21.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2918",
    transform: "translate(14.482 186.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13176",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2917",
    transform: "translate(0 7.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13177",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13178",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2912",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13179",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.4,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13180",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.4,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2913",
    transform: "translate(6.12 4.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13181",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.5,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13182",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.5,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2914",
    transform: "translate(9.588 5.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13183",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13184",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2915",
    transform: "translate(48.818 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13185",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13186",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2916",
    transform: "translate(46.486 3.228)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13187",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13188",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2926",
    transform: "translate(14.482 183.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13189",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2925",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13190",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13191",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2920",
    transform: "translate(0.035 0.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13192",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13193",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2921",
    transform: "translate(6.12 4.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13194",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13195",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2922",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13196",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13197",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2923",
    transform: "translate(48.818 0.044)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13198",
    className: "st9",
    d: "M0,2.7v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2.1,0,2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13199",
    className: "st13",
    d: "M0,2.7v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2.1,0,2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2924",
    transform: "translate(46.486 3.219)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13200",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13201",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2934",
    transform: "translate(14.482 180.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2927",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13202",
    className: "st8",
    d: "M25.2,0C11.2,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39,0,25.2,0z  M25.4,13C13.1,13,3.2,10.4,3.2,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2933",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13203",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13204",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2928",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13205",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13206",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2929",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13207",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13208",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2930",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13209",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13210",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2931",
    transform: "translate(48.818 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13211",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13212",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2932",
    transform: "translate(46.486 3.211)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13213",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13214",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2942",
    transform: "translate(14.482 177.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13215",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2941",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13216",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13217",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2936",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13218",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13219",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2937",
    transform: "translate(6.12 4.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13220",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13221",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2938",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13222",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13223",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2939",
    transform: "translate(48.818 0.053)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13224",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13225",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2940",
    transform: "translate(46.486 3.219)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13226",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13227",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2950",
    transform: "translate(14.482 174.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13228",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2949",
    transform: "translate(0 7.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13229",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13230",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2944",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13231",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13232",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2945",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13233",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13234",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2946",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13235",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13236",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2947",
    transform: "translate(48.818 0.089)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13237",
    className: "st9",
    d: "M0,2.6v2.8c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13238",
    className: "st13",
    d: "M0,2.6v2.8c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2948",
    transform: "translate(46.486 3.22)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13239",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13240",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2958",
    transform: "translate(14.482 171.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13241",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_58",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2957",
    transform: "translate(0 7.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13242",
    className: "st10",
    d: "M25.2,7.9C10.9,7.9,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.9,25.2,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13243",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2952",
    transform: "translate(0.035 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13244",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13245",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2953",
    transform: "translate(6.12 4.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13246",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13247",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2954",
    transform: "translate(9.588 5.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13248",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13249",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2955",
    transform: "translate(48.818 0.08)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13250",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13251",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2956",
    transform: "translate(46.486 3.211)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13252",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13253",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2966",
    transform: "translate(14.482 168.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13254",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.5,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_59",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2965",
    transform: "translate(0 7.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13255",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13256",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2960",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13257",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.7,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13258",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.7,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2961",
    transform: "translate(6.12 4.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13259",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13260",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2962",
    transform: "translate(9.588 5.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13261",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13262",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2963",
    transform: "translate(48.818 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13263",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13264",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2964",
    transform: "translate(46.486 3.228)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13265",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13266",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2974",
    transform: "translate(14.482 165.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13267",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2973",
    transform: "translate(0 7.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13268",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13269",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2968",
    transform: "translate(0.035 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13270",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13271",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2969",
    transform: "translate(6.12 4.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13272",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.1,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13273",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.1,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2970",
    transform: "translate(9.588 5.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13274",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13275",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2971",
    transform: "translate(48.818 0.071)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13276",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13277",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2972",
    transform: "translate(46.486 3.211)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13278",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13279",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2982",
    transform: "translate(14.482 162.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13280",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_61",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2981",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13281",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13282",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2976",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13283",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13284",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2977",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13285",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13286",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2978",
    transform: "translate(9.588 5.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13287",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13288",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2979",
    transform: "translate(48.818 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13289",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13290",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2980",
    transform: "translate(46.486 3.219)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13291",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13292",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2990",
    transform: "translate(14.482 159.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13293",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.7,25.2,7.7c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.6,22.1-5.6s22.1,2.5,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2989",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13294",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13295",
    className: "st9",
    d: "M25.2,7.7C10.9,7.7,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.7,25.2,7.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2984",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13296",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13297",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2985",
    transform: "translate(6.12 4.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13298",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C1,0.3,0.5,0.1,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13299",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C1,0.3,0.5,0.1,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2986",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13300",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13301",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2987",
    transform: "translate(48.818 0.053)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13302",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13303",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2988",
    transform: "translate(46.486 3.219)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13304",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13305",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2998",
    transform: "translate(14.482 156.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13306",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_63",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2997",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13307",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13308",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2992",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13309",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13310",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2993",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13311",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13312",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2994",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13313",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13314",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2995",
    transform: "translate(48.818 0.089)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13315",
    className: "st9",
    d: "M0,2.6v2.8c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13316",
    className: "st13",
    d: "M0,2.6v2.8c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2996",
    transform: "translate(46.486 3.219)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13317",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13318",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3006",
    transform: "translate(14.482 152.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13319",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.7,25.2,7.7c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.5,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3005",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13320",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13321",
    className: "st9",
    d: "M25.2,7.7C10.9,7.7,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.7,25.2,7.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3000",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13322",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13323",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3001",
    transform: "translate(6.12 4.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13324",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13325",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3002",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13326",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13327",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3003",
    transform: "translate(48.818 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13328",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13329",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3004",
    transform: "translate(46.486 3.228)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13330",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13331",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3014",
    transform: "translate(14.482 150.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13332",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.5,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3013",
    transform: "translate(0 7.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13333",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13334",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3008",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13335",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13336",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3009",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13337",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13338",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3010",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13339",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13340",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3011",
    transform: "translate(48.818 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13341",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13342",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3012",
    transform: "translate(46.486 3.202)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13343",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13344",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3022",
    transform: "translate(14.482 147.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13345",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3021",
    transform: "translate(0 7.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13346",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13347",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3016",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13348",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13349",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3017",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13350",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13351",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3018",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13352",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13353",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,2.9,1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3019",
    transform: "translate(48.818 0.063)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13354",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13355",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3020",
    transform: "translate(46.486 3.22)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13356",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13357",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3030",
    transform: "translate(14.482 144.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13358",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.7,25.2,7.7c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3029",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13359",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13360",
    className: "st9",
    d: "M25.2,7.7C10.9,7.7,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.7,25.2,7.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3024",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13361",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13362",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3025",
    transform: "translate(6.12 4.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13363",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13364",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3026",
    transform: "translate(9.588 5.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13365",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13366",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3027",
    transform: "translate(48.818 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13367",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13368",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3028",
    transform: "translate(46.486 3.237)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13369",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13370",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3038",
    transform: "translate(52.001 198.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13371",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_68",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3037",
    transform: "translate(0 7.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13372",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13373",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13374",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13375",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3033",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13376",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13377",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3034",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13378",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13379",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3035",
    transform: "translate(48.791 0.08)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13380",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13381",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3036",
    transform: "translate(46.486 3.22)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13382",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13383",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3046",
    transform: "translate(52.001 195.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13384",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.5,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_69",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3045",
    transform: "translate(0 7.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13385",
    className: "st10",
    d: "M25.2,7.9C10.9,7.9,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.9,25.2,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13386",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3040",
    transform: "translate(0 0.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13387",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.7,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13388",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.7,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3041",
    transform: "translate(6.12 4.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13389",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13390",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3042",
    transform: "translate(9.588 6.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13391",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13392",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3043",
    transform: "translate(48.791 0.089)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13393",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13394",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3044",
    transform: "translate(46.486 3.211)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13395",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13396",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3054",
    transform: "translate(52.001 192.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13397",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.5,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3053",
    transform: "translate(0 7.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13398",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13399",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3048",
    transform: "translate(0 0.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13400",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13401",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3049",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13402",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13403",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3050",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13404",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13405",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3051",
    transform: "translate(48.791 0.044)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13406",
    className: "st9",
    d: "M0,2.7v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2.1,0,2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13407",
    className: "st13",
    d: "M0,2.7v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2.1,0,2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3052",
    transform: "translate(46.486 3.211)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13408",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13409",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3062",
    transform: "translate(52.001 189.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13410",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.5,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_71",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3061",
    transform: "translate(0 7.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13411",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13412",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3056",
    transform: "translate(0 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13413",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13414",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3057",
    transform: "translate(6.12 4.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13415",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13416",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3058",
    transform: "translate(9.588 5.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13417",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13418",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3059",
    transform: "translate(48.791 0.071)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13419",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13420",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3060",
    transform: "translate(46.486 3.202)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13421",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13422",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3070",
    transform: "translate(52.001 186.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13423",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.6,22.1-5.6s22.1,2.5,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3069",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13424",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13425",
    className: "st9",
    d: "M25.2,7.7C10.9,7.7,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.7,25.2,7.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13426",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13427",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3065",
    transform: "translate(6.12 4.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13428",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C1,0.3,0.5,0.1,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13429",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C1,0.3,0.5,0.1,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3066",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13430",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3C0.9,0.2,0.5,0.1,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13431",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3C0.9,0.2,0.5,0.1,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3067",
    transform: "translate(48.791 0.053)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13432",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13433",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3068",
    transform: "translate(46.486 3.219)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13434",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13435",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3078",
    transform: "translate(52.001 183.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13436",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3077",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13437",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13438",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13439",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13440",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3073",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13441",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13442",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3074",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13443",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13444",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3075",
    transform: "translate(48.791 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13445",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13446",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3076",
    transform: "translate(46.486 3.22)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13447",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13448",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3086",
    transform: "translate(52.001 180.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13449",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3085",
    transform: "translate(0 7.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13450",
    className: "st10",
    d: "M25.2,7.9C10.9,7.9,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.9,25.2,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13451",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3080",
    transform: "translate(0 0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13452",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13453",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3081",
    transform: "translate(6.12 4.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13454",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13455",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3082",
    transform: "translate(9.588 5.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13456",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13457",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3083",
    transform: "translate(48.791 0.079)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13458",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13459",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3084",
    transform: "translate(46.486 3.211)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13460",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13461",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3094",
    transform: "translate(52.001 177.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13462",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3093",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13463",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13464",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13465",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13466",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3089",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13467",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13468",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3090",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13469",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13470",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3091",
    transform: "translate(48.791 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13471",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13472",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3092",
    transform: "translate(46.486 3.219)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13473",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13474",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3102",
    transform: "translate(52.001 174.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13475",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3101",
    transform: "translate(0 7.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13476",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13477",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13478",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13479",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3097",
    transform: "translate(6.12 4.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13480",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13481",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3098",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13482",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13483",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3099",
    transform: "translate(48.791 0.063)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13484",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13485",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3100",
    transform: "translate(46.486 3.255)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13486",
    className: "st9",
    d: "M0,0.8v2.7C0.5,3.3,1.1,3,1.6,2.7V0C1.1,0.3,0.5,0.6,0,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13487",
    className: "st13",
    d: "M0,0.8v2.7C0.5,3.3,1.1,3,1.6,2.7V0C1.1,0.3,0.5,0.6,0,0.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3110",
    transform: "translate(52.001 171.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13488",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.3,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.6,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3109",
    transform: "translate(0 7.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13489",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13490",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13491",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13492",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3105",
    transform: "translate(6.12 4.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13493",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13494",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3106",
    transform: "translate(9.588 5.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13495",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13496",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3107",
    transform: "translate(48.791 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13497",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13498",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3108",
    transform: "translate(46.486 3.228)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13499",
    className: "st9",
    d: "M0,0.9v2.7C0.5,3.3,1.1,3,1.6,2.7V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13500",
    className: "st13",
    d: "M0,0.9v2.7C0.5,3.3,1.1,3,1.6,2.7V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3118",
    transform: "translate(52.001 168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13501",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.6,22.1-5.6s22.1,2.5,22.1,5.7S37.6,13,25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3117",
    transform: "translate(0 7.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13502",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0.2 C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13503",
    className: "st9",
    d: "M25.2,7.7C10.9,7.7,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.7,25.2,7.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13504",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13505",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.8C1.2,2.6,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3113",
    transform: "translate(6.12 4.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13506",
    className: "st9",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C1,0.3,0.5,0.1,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13507",
    className: "st11",
    d: "M0,0v2.7C0.4,2.8,0.9,3,1.4,3.1V0.5C1,0.3,0.5,0.1,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3114",
    transform: "translate(9.588 5.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13508",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3C0.9,0.2,0.5,0.1,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13509",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3C0.9,0.2,0.5,0.1,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3115",
    transform: "translate(48.791 0.054)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13510",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13511",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3116",
    transform: "translate(46.486 3.22)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13512",
    className: "st9",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13513",
    className: "st13",
    d: "M0,0.9v2.7c0.5-0.3,1.1-0.6,1.6-0.9V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3126",
    transform: "translate(52.001 167.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13514",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3,0,6.7s10.9,7.1,25.2,7.1c14.8,0,25.2-3.4,25.2-7.1S39.1,0,25.2,0z  M25.4,12C13.2,12,3.3,9.6,3.3,6.7s9.9-5.3,22.1-5.3s22.1,2.4,22.1,5.3S37.6,12,25.4,12z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    className: "st9",
    cx: 25.4,
    cy: 6.7,
    rx: 22.1,
    ry: 5.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3125",
    transform: "translate(0 6.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13515",
    className: "st10",
    d: "M25.2,7.3C10.9,7.3,0,3.9,0,0.2v2.5c0,3.6,11.3,7.1,25.2,7.1c15.4,0,25.2-3.5,25.2-7.1V0.2 C50.4,3.9,40,7.3,25.2,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13516",
    className: "st9",
    d: "M25.2,7.1C10.9,7.1,0,3.7,0,0v2.5c0,3.6,11.3,7.1,25.2,7.1c15.4,0,25.2-3.5,25.2-7.1V0 C50.4,3.7,40,7.1,25.2,7.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13517",
    className: "st9",
    d: "M0,0v2.5c0,1.2,1.2,2.4,3.4,3.4V3.4C1.2,2.4,0,1.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13518",
    className: "st11",
    d: "M0,0v2.5c0,1.2,1.2,2.4,3.4,3.4V3.4C1.2,2.4,0,1.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3121",
    transform: "translate(6.12 4.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13519",
    className: "st9",
    d: "M0,0v2.5c0.4,0.1,0.9,0.3,1.4,0.4V0.4C0.9,0.3,0.4,0.1,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13520",
    className: "st11",
    d: "M0,0v2.5c0.4,0.1,0.9,0.3,1.4,0.4V0.4C0.9,0.3,0.4,0.1,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3122",
    transform: "translate(9.588 5.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13521",
    className: "st9",
    d: "M0,0v2.5l1.4,0.3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13522",
    className: "st11",
    d: "M0,0v2.5l1.4,0.3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3123",
    transform: "translate(48.791 0.057)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13523",
    className: "st9",
    d: "M0,2.4v2.5c0.9-0.5,1.5-1.4,1.6-2.5V0C1.5,1,0.9,1.9,0,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13524",
    className: "st13",
    d: "M0,2.4v2.5c0.9-0.5,1.5-1.4,1.6-2.5V0C1.5,1,0.9,1.9,0,2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3124",
    transform: "translate(46.486 2.992)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13525",
    className: "st9",
    d: "M0,0.8v2.5c0.5-0.2,1.1-0.5,1.6-0.8V0C1.1,0.3,0.5,0.6,0,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13526",
    className: "st13",
    d: "M0,0.8v2.5c0.5-0.2,1.1-0.5,1.6-0.8V0C1.1,0.3,0.5,0.6,0,0.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3127",
    transform: "translate(239.162 166.736)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    className: "st8",
    cx: 23.8,
    cy: 23.8,
    r: 23.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    className: "st15",
    cx: 23.8,
    cy: 23.8,
    r: 23.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    className: "st8",
    cx: 23.8,
    cy: 23.8,
    r: 23.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    className: "st9",
    cx: 23.8,
    cy: 23.8,
    r: 18.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13527",
    className: "st8",
    d: "M26.1,34.5C25,34.5,24,34.4,23,34c-0.9-0.3-1.8-0.8-2.6-1.4c-0.8-0.7-1.5-1.5-2-2.4 c-0.5-0.9-0.9-1.8-1.1-2.8C17.3,27.2,17,27,16.8,27h-1.1c-0.3,0-0.5-0.2-0.5-0.5c0,0,0,0,0,0v-1.2c0-0.3,0.2-0.5,0.5-0.5l1.3-0.1 v-1.2c0-0.2,0-0.3,0-0.5h-1.3c-0.3,0-0.5-0.2-0.5-0.5c0,0,0,0,0,0l0,0v-1.2c0-0.3,0.2-0.5,0.5-0.6l1.2-0.1c0.2,0,0.4-0.2,0.5-0.4 c0.5-2,1.6-3.9,3.2-5.2c1.7-1.3,3.8-2,5.9-2c1.1,0,2.2,0.2,3.2,0.7c0.9,0.4,1.7,0.9,2.4,1.5c0.2,0.2,0.2,0.5,0,0.8c0,0,0,0,0,0 l0,0l0,0l-1.9,1.9c-0.2,0.2-0.5,0.2-0.7,0c-0.4-0.3-0.8-0.5-1.2-0.7c-0.6-0.3-1.2-0.4-1.8-0.4c-1,0-2,0.3-2.7,1 c-0.6,0.6-1,1.3-1.3,2.1c-0.1,0.3,0,0.6,0.3,0.7c0,0,0,0,0,0h0c0.1,0,0.1,0,0.2,0h6.9c0.3,0,0.5,0.2,0.5,0.5c0,0,0,0,0,0l0,0v1.3 c0,0.3-0.2,0.5-0.5,0.5c0,0,0,0,0,0h-8c0,0.1,0,0.3,0,0.4V24c0,0.1,0,0.3,0,0.4h6.7c0.3,0,0.5,0.2,0.5,0.5c0,0,0,0,0,0v1.4 c0,0.3-0.2,0.5-0.5,0.6h-5.6c-0.3,0-0.5,0.3-0.5,0.6l0,0c0,0.1,0,0.1,0,0.2c0.3,0.8,0.7,1.5,1.3,2.1c0.8,0.7,1.7,1,2.7,1 c0.7,0,1.4-0.1,2-0.5c0.5-0.2,0.9-0.5,1.3-0.9c0.2-0.2,0.6-0.2,0.8,0l1.8,1.8c0.2,0.2,0.2,0.6,0,0.8l0,0c-0.7,0.8-1.6,1.4-2.6,1.8 C28.5,34.3,27.3,34.5,26.1,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13528",
    className: "st4",
    d: "M0,24.2v1.1c4.4,5.1,10.9,8.1,17.7,8C30,33.3,40,24.1,40,12.9c0-2.5-0.5-5-1.5-7.3 C28.2-2.6,13.3-0.9,5.1,9.4C1.8,13.6,0,18.8,0,24.2L0,24.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3136",
    transform: "translate(14.49 140.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3135",
    transform: "translate(0 0.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13529",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3.2,0,7.3s10.9,7.6,25.2,7.6c14.8,0,25.2-3.6,25.2-7.6S39.1,0,25.2,0z  M25.4,13C13.2,13,3.3,10.4,3.3,7.3s9.9-5.7,22.1-5.7s22.1,2.5,22.1,5.7S37.6,13,25.4,13L25.4,13z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    className: "st9",
    cx: 25.4,
    cy: 7.3,
    rx: 22.1,
    ry: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3134",
    transform: "translate(0 7.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13530",
    className: "st10",
    d: "M25.2,7.8C10.9,7.8,0,4.2,0,0.2v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7 V0.2C50.4,4.2,40,7.8,25.2,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13531",
    className: "st9",
    d: "M25.2,7.6C10.9,7.6,0,4,0,0v2.7c0,3.9,11.3,7.7,25.2,7.7c15.4,0,25.2-3.8,25.2-7.7V0 C50.4,4,40,7.6,25.2,7.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3129",
    transform: "translate(0.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13532",
    className: "st9",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.7,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13533",
    className: "st11",
    d: "M0,0v2.7C0,4,1.2,5.2,3.4,6.4V3.7C1.2,2.7,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3130",
    transform: "translate(6.121 4.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13534",
    className: "st9",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13535",
    className: "st11",
    d: "M0,0v2.7C0.5,2.8,0.9,3,1.4,3.1V0.5C0.9,0.3,0.4,0.2,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3131",
    transform: "translate(9.588 5.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13536",
    className: "st9",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13537",
    className: "st11",
    d: "M0,0v2.7L1.4,3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3132",
    transform: "translate(48.81 0.062)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13538",
    className: "st9",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13539",
    className: "st13",
    d: "M0,2.6v2.7c0.9-0.6,1.5-1.6,1.6-2.7V0C1.5,1.1,0.9,2,0,2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3133",
    transform: "translate(46.487 3.228)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13540",
    className: "st9",
    d: "M0,0.9v2.7C0.5,3.3,1.1,3,1.6,2.7V0C1.1,0.3,0.5,0.6,0,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13541",
    className: "st13",
    d: "M0,0.9v2.7C0.5,3.3,1.1,3,1.6,2.7V0C1.1,0.3,0.5,0.6,0,0.9z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13542",
    className: "st8",
    d: "M27,11.3c-1.1,0-2.2-0.1-3.3-0.2c-0.9-0.1-1.9-0.3-2.8-0.5c-0.7-0.2-1.4-0.5-2.1-0.9 c-0.5-0.3-0.9-0.6-1.2-1.1c-0.2-0.1-0.4-0.2-0.6-0.2h-1.1c-0.3,0-0.6-0.1-0.6-0.2V7.8c0-0.1,0.2-0.2,0.5-0.2h1.3V7.2 c0-0.1,0-0.1,0-0.2h-1.3c-0.3,0-0.6-0.1-0.6-0.2V6.3c0-0.1,0.2-0.2,0.5-0.2h1.3c0.2,0,0.4,0,0.5-0.2c0.9-1,2.1-1.7,3.4-2 c3.2-0.8,6.5-0.9,9.8-0.5c0.9,0.1,1.7,0.3,2.5,0.6c0.2,0.1,0.2,0.2,0,0.3l-2,0.7c-0.2,0.1-0.5,0.1-0.8,0c-0.4-0.1-0.9-0.2-1.3-0.3 c-0.7-0.1-1.4-0.2-2-0.1c-1,0-2,0.1-2.9,0.4c-0.5,0.2-1,0.4-1.4,0.8c-0.1,0.1,0.2,0.3,0.6,0.3h7.4c0.3,0,0.6,0.1,0.6,0.2v0.5 c0,0.1-0.3,0.2-0.6,0.2h-8.6c0,0,0,0.1,0,0.2v0.3c0,0,0,0.1,0,0.2h7.2c0.3,0,0.6,0.1,0.6,0.2v0.5c0,0.1-0.3,0.2-0.6,0.2h-6 c-0.4,0-0.7,0.1-0.5,0.3c0.4,0.4,0.9,0.6,1.4,0.8c0.9,0.3,1.9,0.4,2.9,0.4c0.7,0,1.5-0.1,2.2-0.2c0.5-0.1,0.9-0.2,1.3-0.3 c0.3-0.1,0.6-0.1,0.8,0l2,0.6c0.2,0.1,0.2,0.2,0,0.3c-0.9,0.3-1.8,0.5-2.8,0.7C29.6,11.3,28.3,11.3,27,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13543",
    className: "st4",
    d: "M0,7.7V8c4.3,1.6,11.2,2.6,18.8,2.6c13.1,0,23.7-3,23.7-6.6c-0.1-1-0.7-1.9-1.6-2.4 C35.8,0.5,30.6,0,25.3,0C11.3,0,0,3.5,0,7.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3145",
    transform: "translate(51.984 164.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3144",
    transform: "translate(0.024 0.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13544",
    className: "st8",
    d: "M25.2,0C11.3,0,0,3,0,6.7s10.9,7.1,25.2,7.1c14.8,0,25.2-3.4,25.2-7.1S39.1,0,25.2,0z  M25.4,12C13.2,12,3.3,9.6,3.3,6.7s9.9-5.3,22.1-5.3s22.1,2.4,22.1,5.3S37.6,12,25.4,12L25.4,12z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    className: "st9",
    cx: 25.4,
    cy: 6.7,
    rx: 22.1,
    ry: 5.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3143",
    transform: "translate(0 6.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13545",
    className: "st10",
    d: "M25.2,7.3C10.9,7.3,0,3.9,0,0.2v2.5c0,3.6,11.3,7.1,25.2,7.1c15.4,0,25.2-3.5,25.2-7.1 V0.2C50.4,3.9,40,7.3,25.2,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13546",
    className: "st9",
    d: "M25.2,7.1C10.9,7.1,0,3.7,0,0v2.5c0,3.6,11.3,7.1,25.2,7.1c15.4,0,25.2-3.5,25.2-7.1V0 C50.4,3.7,40,7.1,25.2,7.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3138",
    transform: "translate(0 0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13547",
    className: "st9",
    d: "M0,0v2.5c0,1.2,1.2,2.4,3.4,3.4V3.4C1.2,2.4,0,1.3,0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13548",
    className: "st11",
    d: "M0,0v2.5c0,1.2,1.2,2.4,3.4,3.4V3.4C1.2,2.4,0,1.3,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3139",
    transform: "translate(6.121 4.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13549",
    className: "st9",
    d: "M0,0v2.5c0.4,0.1,0.9,0.3,1.4,0.4V0.4L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13550",
    className: "st11",
    d: "M0,0v2.5c0.4,0.1,0.9,0.3,1.4,0.4V0.4L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3140",
    transform: "translate(9.588 5.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13551",
    className: "st9",
    d: "M0,0v2.5l1.4,0.3V0.3L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13552",
    className: "st11",
    d: "M0,0v2.5l1.4,0.3V0.3L0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3141",
    transform: "translate(48.792 0.074)",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13553",
    className: "st9",
    d: "M0,2.4v2.5c0.9-0.5,1.5-1.4,1.6-2.5V0C1.4,1,0.9,1.9,0,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13554",
    className: "st13",
    d: "M0,2.4v2.5c0.9-0.5,1.5-1.4,1.6-2.5V0C1.4,1,0.9,1.9,0,2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3142",
    transform: "translate(46.486 2.975)",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13555",
    className: "st9",
    d: "M0,0.8v2.5c0.5-0.2,1.1-0.5,1.6-0.8V0C1.1,0.3,0.5,0.6,0,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13556",
    className: "st13",
    d: "M0,0.8v2.5c0.5-0.2,1.1-0.5,1.6-0.8V0C1.1,0.3,0.5,0.6,0,0.8z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13557",
    className: "st8",
    d: "M27.1,10.5c-1.1,0-2.2-0.1-3.3-0.2c-0.9-0.1-1.9-0.3-2.8-0.5c-0.7-0.2-1.4-0.5-2.1-0.8 c-0.5-0.2-0.9-0.6-1.2-1c-0.2-0.1-0.4-0.2-0.6-0.1h-1.2c-0.3,0-0.6-0.1-0.6-0.2V7.2c0-0.1,0.2-0.2,0.5-0.2h1.3V6.6 c0-0.1,0-0.1,0-0.2h-1.3c-0.3,0-0.6-0.1-0.6-0.2V5.9c0-0.1,0.2-0.2,0.6-0.2h1.3c0.2,0,0.4,0,0.5-0.1c0.9-0.9,2.1-1.6,3.4-1.8 c3.2-0.7,6.5-0.9,9.8-0.5c0.9,0.1,1.7,0.3,2.5,0.5c0.2,0.1,0.2,0.2,0,0.3l-2,0.6c-0.2,0.1-0.5,0.1-0.8,0c-0.4-0.1-0.9-0.2-1.3-0.3 c-0.7-0.1-1.3-0.2-2-0.2c-1,0-2,0.1-2.9,0.3c-0.5,0.1-1,0.4-1.4,0.7c-0.1,0.1,0.1,0.3,0.6,0.3H31c0.3,0,0.6,0.1,0.6,0.2v0.5 c0,0.1-0.3,0.2-0.6,0.2h-8.6c0,0,0,0.1,0,0.1v0.3c0,0,0,0.1,0,0.1h7.2c0.3,0,0.6,0.1,0.6,0.2v0.5c0,0.1-0.3,0.2-0.6,0.2h-6 c-0.4,0-0.7,0.1-0.6,0.3c0.4,0.3,0.9,0.6,1.4,0.7c1,0.3,1.9,0.4,2.9,0.3c0.7,0,1.5,0,2.2-0.2c0.5-0.1,0.9-0.2,1.3-0.3 c0.3-0.1,0.6-0.1,0.8,0l2,0.6c0.2,0.1,0.2,0.2,0,0.3c-0.9,0.3-1.8,0.5-2.8,0.6C29.6,10.4,28.4,10.5,27.1,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13558",
    className: "st4",
    d: "M0,7.1c0,0.1,0,0.2,0,0.3c4.3,1.5,11.1,2.4,18.8,2.4c13.1,0,23.7-2.7,23.7-6.1 C42.4,2.8,41.8,2,41,1.5C35.8,0.5,30.6-0.1,25.3,0C11.3,0,0,3.2,0,7.1z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-rgb.fcbac829289c5457296d186c313cc360.svg";